import React, { Component } from 'react';
import Hls from 'hls.js/dist/hls.light.min';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function createMasterM3U8(list) {
    const result = [];
    result.push('#EXTM3U');
    list.forEach((item) => {
        const meta = {
            'PROGRAM-ID': '1',
            BANDWIDTH: String(item.bandwidth),
        };
        if (item.resolution) {
            const { width, height } = item.resolution;
            meta.RESOLUTION = `${width}x${height}`;
        }
        result.push(`#EXT-X-STREAM-INF:${Object.entries(meta)
            .map(([key, value]) => `${key}=${value}`)
            .join(',')}`);
        result.push(item.source);
    });
    return result.join('\n');
}

var getMasterM3U8Blob = (sources) => {
    const list = sources.map((item) => ({
        source: item.source,
        bandwidth: item.bitrate * 1024,
        resolution: {
            width: item.width,
            height: item.height,
        },
    }));
    return new Blob([createMasterM3U8(list)], {
        type: 'application/vnd.apple.mpegURL',
    });
};

class VideoComponent extends Component {
    constructor() {
        super(...arguments);
        this.video = null;
        this.manuallyBuildAdaptiveM3U8Blob = false;
        this.hasLoadStarted = false;
    }
    componentDidMount() {
        const { src, sources, useAutoQuality } = this.props;
        this.hls = new Hls({ autoStartLoad: false });
        this.hls.attachMedia(this.video);
        const isAutoQualitySourceProvided = Boolean(sources.find((s) => s.quality === 'auto'));
        // 启用自动质量但是又没有提供 auto 规格的 source，那么就尝试本地手动生成
        if (useAutoQuality && !isAutoQualitySourceProvided) {
            const master = getMasterM3U8Blob(sources);
            this.src = URL.createObjectURL(master);
            this.manuallyBuildAdaptiveM3U8Blob = true;
        }
        else {
            this.src = src;
        }
        this.hls.loadSource(this.src);
    }
    componentDidUpdate(prevProps) {
        const { currentQuality, sources, paused, src } = this.props;
        if (!this.hls) {
            return;
        }
        if (currentQuality !== prevProps.currentQuality || prevProps.src !== src) {
            // 切换清晰度
            const source = sources.find((s) => s.quality === currentQuality);
            if (source) {
                if (this.manuallyBuildAdaptiveM3U8Blob) {
                    const levels = this.hls.levels;
                    const level = levels.findIndex((l) => l.url.includes(source.source));
                    this.hls.nextLevel = level;
                }
                else {
                    // TODO: 没有在 hls 的 API 内部找到顺畅切换 source 的方法
                    // 因此这里比较直接和生硬
                    const currentTime = this.video.currentTime;
                    this.hls.destroy();
                    this.hls = new Hls({ autoStartLoad: false });
                    this.hls.attachMedia(this.video);
                    this.hls.loadSource(source.source);
                    this.video.currentTime = currentTime;
                    this.hls.startLoad();
                    if (!paused) {
                        void this.video.play();
                    }
                }
            }
            else {
                // 一定意味着选择了手动生成的「auto」
                this.hls.nextLevel = -1;
            }
        }
        // 切换播放状态
        if (!paused && prevProps.paused && !this.hasLoadStarted) {
            this.hls.startLoad();
            this.hasLoadStarted = true;
        }
    }
    componentWillUnmount() {
        this.hls.destroy();
        if (this.manuallyBuildAdaptiveM3U8Blob) {
            URL.revokeObjectURL(this.src);
        }
    }
    render() {
        const _a = this.props, { onRef, 
        /* eslint-disable @typescript-eslint/no-unused-vars */
        currentQuality, useAutoQuality, src, sources, paused } = _a, 
        /* eslint-enable @typescript-eslint/no-unused-vars */
        props = __rest(_a, ["onRef", "currentQuality", "useAutoQuality", "src", "sources", "paused"]);
        return (React.createElement("video", Object.assign({ ref: (el) => {
                if (onRef) {
                    onRef(el);
                }
                this.video = el;
            } }, props)));
    }
}

var index = {
    pluginName: 'griffith-hls',
    VideoComponent,
    willHandleSrcChange: true,
};

export { index as default };
